import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import { useRef, useState } from "react";
import type { DateCalculationType } from "./utilities/dateCalculationTypes";
import { dateCalculationTypes, getDateCalculationCaption } from "./utilities/dateCalculationTypes";

interface Props {
  onDateCalculationItemClick: (type: DateCalculationType, event: React.MouseEvent<HTMLElement>) => void;
}

const DateCalculationMenuItem = ({ onDateCalculationItemClick }: Props) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const handleMouseLeave = (target: EventTarget | null) => {
    if (target instanceof Node && menuRef.current?.contains(target)) {
      return;
    }
    setAnchor(null);
  };

  return (
    <>
      <MenuItem
        onMouseEnter={(e) => {
          setAnchor(e.currentTarget);
          e.stopPropagation();
        }}
        onMouseLeave={(e) => handleMouseLeave(e.relatedTarget)}
        onClick={(e) => {
          setAnchor((prev) => (prev ? null : e.currentTarget));
          e.stopPropagation();
        }}
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <ListItemText>
          <Typography>Date</Typography>
        </ListItemText>
        <ChevronRightRoundedIcon color="action" />
      </MenuItem>
      <Menu
        ref={menuRef}
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        sx={{ pointerEvents: "none" }}
        slotProps={{ paper: { sx: { pointerEvents: "auto", minWidth: 180 } } }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {dateCalculationTypes.map((type) => (
          <MenuItem key={type} onClick={(event) => onDateCalculationItemClick(type, event)}>
            <Typography>{getDateCalculationCaption(type)}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default DateCalculationMenuItem;
